import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { educationApi, bookingsApi } from '../utils/api';
import { getImageUrl } from '../config/imageConfig';
import CarouselBanner from './common/CarouselBanner';
import './Learning.css';

// 导入科学教育图片
import j1Img from '../assets/kxjy/j1.png';
import j2Img from '../assets/kxjy/j2.png';
import j3Img from '../assets/kxjy/j3.png';

function Learning() {
  // API数据状态
  const [courses, setCourses] = useState([]);
  const [programs, setPrograms] = useState([]);
  const [publications, setPublications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [enrollmentLoading, setEnrollmentLoading] = useState({});
  
  // 获取教育数据
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const [coursesData, programsData, publicationsData] = await Promise.all([
          educationApi.getCourses(),
          educationApi.getSchoolPrograms(),
          educationApi.getPublications()
        ]);
        setCourses(Array.isArray(coursesData?.data) ? coursesData.data : defaultCourses);
        setPrograms(Array.isArray(programsData?.data) ? programsData.data : defaultPrograms);
        setPublications(Array.isArray(publicationsData?.data) ? publicationsData.data : defaultPublications);
      } catch (err) {
        console.error('Error fetching education data:', err);
        setError(err.message);
        // 使用默认数据作为备用
        setCourses(defaultCourses);
        setPrograms(defaultPrograms);
        setPublications(defaultPublications);
      } finally {
        setLoading(false);
      }
    };
    
    fetchData();
  }, []);
  
  // 课程报名处理
  const handleEnrollCourse = async (courseId) => {
    try {
      setEnrollmentLoading(prev => ({ ...prev, [courseId]: true }));
      await bookingsApi.createBooking({ courseId, type: 'course' });
      alert('课程报名成功！我们会尽快与您联系确认。');
    } catch (err) {
      console.error('Error enrolling course:', err);
      alert('报名失败，请稍后重试');
    } finally {
      setEnrollmentLoading(prev => ({ ...prev, [courseId]: false }));
    }
  };
  
  // 图片资源 - 使用全局配置处理URL
  const learningHeroImg = getImageUrl('https://images.unsplash.com/photo-1581078426770-6d336e5de7bf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80');
  const courseImg1 = getImageUrl('https://images.unsplash.com/photo-1594489573802-74db03803db2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80');
  const courseImg2 = getImageUrl('https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80');
  const courseImg3 = getImageUrl('https://images.unsplash.com/photo-1596387451750-8d4e7a960b69?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80');
  const schoolProgramImg = getImageUrl('https://images.unsplash.com/photo-1539634437206-6d6e62ca7072?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80');
  const researchImg = getImageUrl('https://images.unsplash.com/photo-1581093196277-9f6e9b963366?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80');
  const publicationImg = getImageUrl('https://images.unsplash.com/photo-1513475382585-d06e58bcb0e0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80');
  const digitalResourceImg = 'https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80';
  
  // 默认课程数据
  const defaultCourses = [
    {
      id: 1,
      title: '中药植物识别入门',
      image: courseImg1,
      duration: '4周课程，每周2小时',
      level: '入门级',
      audience: '植物爱好者、中医学生',
      description: '学习识别常见的药用植物，掌握基本的植物学特征和辨识方法。课程包括室内讲解和户外实践，由资深植物学家授课。',
      highlights: [
        '了解100种常见药用植物',
        '掌握植物分类与识别基础',
        '学习采集和标本制作技术',
        '中药材与植物对应关系'
      ],
      schedule: [
        '第1周：植物识别基础与形态学',
        '第2周：常见药用植物科属特征',
        '第3周：野外识别实践',
        '第4周：标本制作与保存'
      ],
      price: '¥980/人'
    },
    {
      id: 2,
      title: '药用植物栽培技术',
      image: courseImg2,
      duration: '6周课程，每周3小时',
      level: '中级',
      audience: '园艺爱好者、种植从业者',
      description: '系统学习药用植物的栽培技术，包括育苗、土壤管理、病虫害防治等内容，通过理论学习和实践操作相结合的方式掌握技能。',
      highlights: [
        '掌握30种常用药材的栽培方法',
        '学习病虫害绿色防治技术',
        '了解不同药用植物的生长环境需求',
        '药材采收与初加工技术'
      ],
      schedule: [
        '第1-2周：种子处理与育苗技术',
        '第3-4周：栽培管理与病虫害防治',
        '第5周：采收与加工技术',
        '第6周：品质评价与贮藏'
      ],
      price: '¥1680/人'
    },
    {
      id: 3,
      title: '药膳与养生茶饮工作坊',
      image: courseImg3,
      duration: '单日工作坊，6小时',
      level: '所有人',
      audience: '健康生活爱好者、家庭主妇、茶文化爱好者',
      description: '学习传统药膳和养生茶饮的配方与制作方法，了解食材和药材的特性及功效，掌握日常养生保健的实用技能。',
      highlights: [
        '学习8种经典药膳制作',
        '掌握12种养生茶饮配方',
        '了解常用药食同源的材料',
        '四季养生调理原则'
      ],
      schedule: [
        '上午：中医药膳理论基础',
        '中午：药膳实践与品尝',
        '下午：养生茶饮调配技术',
        '傍晚：成果分享与交流'
      ],
      price: '¥580/人（含所有材料）'
    }
  ];
  
  // 默认学校项目数据
  const defaultPrograms = [
    {
      title: '小小植物学家',
      ageGroup: '6-9岁',
      duration: '2小时',
      description: '通过有趣的活动和游戏，让孩子们认识植物的基本特征和生命周期，培养对自然的好奇心和观察力。'
    },
    {
      title: '药用植物大发现',
      ageGroup: '10-13岁',
      duration: '3小时',
      description: '介绍常见的药用植物及其用途，通过制作植物标本和简单的药用制品，了解植物与人类健康的关系。'
    },
    {
      title: '青少年自然科学家',
      ageGroup: '14-18岁',
      duration: '半天',
      description: '深入学习植物学研究方法，参与实际的科学数据收集和分析，培养科学思维和研究能力。'
    }
  ];
  
  // 默认研究与出版物
  const defaultPublications = [
    {
      title: '《庐山药用植物图鉴》',
      author: '杏林研究团队',
      year: '2022',
      description: '全面收录庐山地区300多种药用植物，包含详细图片、特征描述和药用价值说明。'
    },
    {
      title: '《中药材规范化种植技术手册》',
      author: '张教授等',
      year: '2021',
      description: '系统介绍50种常用中药材的规范化种植技术，包括苗期管理、田间管理、病虫害防治等内容。'
    },
    {
      title: '《药用植物资源可持续利用研究》',
      author: '李研究员等',
      year: '2020',
      description: '探讨药用植物资源的可持续开发利用模式，为保护生物多样性提供科学依据。'
    }
  ];

  return (
    <div>
      {/* Hero Section - 使用轮播图组件 */}
      <CarouselBanner 
        categoryNameEn="KXJY"
        defaultImage={learningHeroImg}
        defaultTitle="科学教育"
        defaultSubtitle="探索植物科学的奥秘，传承中医药文化的智慧"
        className="hero-section"
      />
      
      <div className="learning-container">
        {/* 中药资源可持续利用重点实验室 */}
        <section className="key-lab-section">
          <div className="section-card left-image">
            <div className="card-image">
              <img src={j1Img} alt="中药资源实验室" />
            </div>
            <div className="card-content">
              <h2 className="card-title">中药资源可持续利用重点实验室</h2>
              <p className="card-description">
                中药资源可持续利用江西省重点实验室（庐山植物园）2024年4月成立。聚焦中药资源保护与产业升级，围绕含12名省部级人才及28位博士，通过多学科技术开展种质创新、药效鉴析及绿色种植研究。重立种质库、培育抗炎新药品种，制定省级种植标准，推动江西湿地药材高值化利用，助力中医药强省与乡村振兴。
              </p>
              <button className="btn-more">了解详情</button>
            </div>
          </div>
        </section>
        {/* 科学研究成果 */}
        <section className="research-section">
          <div className="section-card right-image">
            <div className="card-content">
              <h2 className="card-title">科学研究成果</h2>
              <p className="card-description">
                种质资源保护与创新、道地药材研究、绿色种植与资源再生、产学研融合
              </p>
              <button className="btn-more">了解详情</button>
            </div>
            <div className="card-image">
              <img src={j2Img} alt="科研成果" />
            </div>
          </div>
        </section>
        {/* 科研基地 */}
        <section className="base-section">
          <div className="section-card left-image">
            <div className="card-image">
              <img src={j3Img} alt="科研基地" />
            </div>
            <div className="card-content">
              <h2 className="card-title">科研基地</h2>
              <p className="card-description">
                种质资源保护与创新、道地药材研究、绿色种植与资源再生、产学研融合
              </p>
              <button className="btn-more">了解详情</button>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default Learning;